var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c("studip-dialog", {
    attrs: {
      title: _vm.title,
      closeText: _vm.$gettext("Schließen"),
      height: "600",
      width: "600",
    },
    on: {
      close: function close($event) {
        return _vm.$emit("close")
      },
    },
    scopedSlots: _vm._u([
      {
        key: "dialogContent",
        fn: function fn() {
          return [
            _c(
              "h2",
              {
                staticClass: "cw-comments-overview-dialog-comments-context",
              },
              [
                _c(
                  "a",
                  {
                    attrs: {
                      href: _vm.contextUrl,
                    },
                  },
                  [_vm._v(_vm._s(_vm.context))]
                ),
              ]
            ),
            _vm._v(" "),
            _vm.isBlock && _vm.isComment
              ? _c("courseware-block-comments", {
                  attrs: {
                    block: _vm.item,
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.isStructuralElement && _vm.isComment
              ? _c("courseware-structural-element-comments", {
                  attrs: {
                    structuralElement: _vm.item,
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.isBlock && _vm.isFeedback
              ? _c("courseware-block-feedback", {
                  attrs: {
                    block: _vm.item,
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.isStructuralElement && _vm.isFeedback
              ? _c("courseware-structural-element-feedback", {
                  attrs: {
                    structuralElement: _vm.item,
                  },
                })
              : _vm._e(),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }